<cc-box>
  <div class="container-responsive" header box>
    {{'ACCOUNTS.BILLING_INFO' | translate}}
  </div>

  <div class="billing-box" content box>
    <div class="values_wrapper" *ngIf="!editMode">
      <button
        mat-raised-button
        type="button"
        (click)="edit()"
        color="info-full"
        *ngIf="!editMode"
        class="change-button">
        <span translate>CHANGE</span>
      </button>
      <cc-label-value
        labelKey="INVOICE_DATA.COMPANY_NAME"
        value="{{billingForm.get('name').value}}">
      </cc-label-value>

      <cc-label-value
        labelKey="INVOICE_DATA.TAX_ID"
        value="{{billingForm.get('taxId').value}}">
      </cc-label-value>

      <cc-label-value
        labelKey="INVOICE_DATA.EMAIL"
        value="{{billingForm.get('email').value}}">
      </cc-label-value>

      <cc-label-value
        labelKey="INVOICE_DATA.PHONE_NUMBER"
        value="{{billingForm.get('phone').value}}">
      </cc-label-value>

      <cc-label-value
        labelKey="INVOICE_DATA.BILLING_ADDRESS"
        value="{{billingForm.get('line1').value + '\n' + billingForm.get('line2').value}}">
      </cc-label-value>

      <cc-label-value
        labelKey="INVOICE_DATA.CITY"
        value="{{billingForm.get('city').value}}">
      </cc-label-value>

      <cc-label-value
        labelKey="INVOICE_DATA.POSTAL_CODE"
        value="{{billingForm.get('postalCode').value}}">
      </cc-label-value>

      <cc-label-value
        labelKey="INVOICE_DATA.COUNTRY"
        value="{{billingForm.get('country').value}}">
      </cc-label-value>

      <cc-label-value
        labelKey="INVOICE_DATA.STATE"
        value="{{billingForm.get('state').value}}">
      </cc-label-value>
    </div>

    <form [formGroup]="billingForm" *ngIf="editMode">
        <cc-input-label-error-wrapper
          labelKey="INVOICE_DATA.COMPANY_NAME"
          placeholder="{{ 'INVOICE_DATA.COMPANY_NAME'| translate}}"
          [form]="billingForm"
          controlName="name"
          tabulatorIndex="1">
        </cc-input-label-error-wrapper>

      <div class="inputs_wrapper">
        <div class="tax-type-box">
            <div class="custom-label" translate>INVOICE_DATA.TAX_TYPE</div>
            <mat-select
              class="action-select tax-type-select"
              [formGroup]="billingForm"
              formControlName="taxType"
              tabIndex="2"
            >
              <mat-option value="">{{ 'NOT_APPLICABLE' | translate}}</mat-option>
              <mat-option
                *ngFor="let item of taxTypes | async"
                [value]="item.value"
              >
                {{ getTaxTypeDescription(item.label) }}
              </mat-option>
            </mat-select>
        </div>

        <cc-input-label-error-wrapper
          labelKey="INVOICE_DATA.PHONE_NUMBER"
          placeholder="{{ 'INVOICE_DATA.PHONE_NUMBER'| translate}}"
          [form]="billingForm"
          controlName="phone"
          tabulatorIndex="4">
        </cc-input-label-error-wrapper>

        <cc-input-label-error-wrapper
          labelKey="INVOICE_DATA.BILLING_ADDRESS"
          placeholder="{{ 'INVOICE_DATA.LINE_1'| translate}}"
          [form]="billingForm"
          controlName="line1"
          tabulatorIndex="6">
        </cc-input-label-error-wrapper>

        <cc-input-label-error-wrapper
          labelKey="INVOICE_DATA.POSTAL_CODE"
          placeholder="{{ 'INVOICE_DATA.POSTAL_CODE'| translate}}"
          [form]="billingForm"
          controlName="postalCode"
          tabulatorIndex="8">
        </cc-input-label-error-wrapper>

        <div class="country-box">
          <div class="custom-label" translate>INVOICE_DATA.COUNTRY</div>
          <cc-country-picker
            [form]="billingForm"
            controlName="country"
            tabulatorIndex="10">
          </cc-country-picker>
        </div>

        <cc-input-label-error-wrapper
          labelKey="INVOICE_DATA.TAX_ID"
          placeholder="{{ 'INVOICE_DATA.TAX_ID'| translate}}"
          [form]="billingForm"
          controlName="taxId"
          tabulatorIndex="3">
        </cc-input-label-error-wrapper>

        <cc-input-label-error-wrapper
          labelKey="INVOICE_DATA.EMAIL"
          placeholder="{{ 'INVOICE_DATA.EMAIL'| translate}}"
          [form]="billingForm"
          controlName="email"
          tabulatorIndex="5">
        </cc-input-label-error-wrapper>

        <cc-input-label-error-wrapper
          labelKey=""
          placeholder="{{ 'INVOICE_DATA.LINE_2'| translate}}"
          [form]="billingForm"
          controlName="line2"
          tabulatorIndex="7">
        </cc-input-label-error-wrapper>

        <cc-input-label-error-wrapper
          labelKey="INVOICE_DATA.CITY"
          placeholder="{{ 'INVOICE_DATA.CITY'| translate}}"
          [form]="billingForm"
          controlName="city"
          tabulatorIndex="9">
        </cc-input-label-error-wrapper>

        <cc-input-label-error-wrapper
          labelKey="INVOICE_DATA.STATE"
          placeholder="{{ 'INVOICE_DATA.STATE'| translate}}"
          [form]="billingForm"
          controlName="state"
          tabulatorIndex="11">
        </cc-input-label-error-wrapper>
      </div>
    </form>

    <div class="button-wrapper">
      <button
        mat-raised-button
        type="button"
        (click)="cancel()"
        *ngIf="editMode"
        color="info-full"
        class="cancel-button">
        <span translate>CANCEL</span>
      </button>
      <button
        mat-raised-button
        type="button"
        (click)="save()"
        *ngIf="editMode"
        color="primary-full">
        <span translate>SAVE</span>
      </button>
    </div>

  </div>

</cc-box>
